import axios from 'axios';
import { getEnvironment } from '@global/helpers';

const Config = getEnvironment();
const baseUrl = Config.MS_SOCO_PUBLIC_API_URL;

const getAppVersions = (platform) => {
  return axios.get(`${baseUrl}/app-versions/${platform}`);
};

export default { getAppVersions };
